import { render, staticRenderFns } from "./EditJumpToBigPic.vue?vue&type=template&id=afd6bb40&scoped=true"
import script from "./EditJumpToBigPic.vue?vue&type=script&lang=js"
export * from "./EditJumpToBigPic.vue?vue&type=script&lang=js"
import style0 from "./EditJumpToBigPic.vue?vue&type=style&index=0&id=afd6bb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6bb40",
  null
  
)

export default component.exports